import React, {useEffect} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import './ComponentCss/TopBar.css'; // 스타일을 위한 CSS 파일

const TopBar = () => {
    const location = useLocation(); // 현재 URL 정보를 가져옴
    const navigate = useNavigate();


    useEffect(() => {
        const checkJwt = () => {
            let jwtToken = sessionStorage.getItem("Authorization");
            if (jwtToken == null) {
                navigate('/');

            }


        };
        checkJwt();
    }, []); // 컴포넌트가 처음 마운트될 때만 실행
    return (
        <nav className="topbar">
            <ul className="topbar-buttons">
                {/*<li>*/}
                {/*    <Link*/}
                {/*        to="/Home"*/}
                {/*        className={location.pathname === '/Home' ? 'active' : ''}*/}
                {/*    >*/}
                {/*        퇴실관리*/}
                {/*    </Link>*/}
                {/*</li>*/}

                <li>
                    <Link
                        to="/Payment"
                        className={location.pathname === '/Payment' ? 'active' : ''}
                    >
                        메인
                    </Link>
                </li>
                <li>
                    <Link
                        to="/Registration"
                        className={location.pathname === '/Registration' ? 'active' : ''}
                    >
                        등록
                    </Link>
                </li>


                <li>
                    <Link
                        to="/Print"
                        className={location.pathname === '/Print' ? 'active' : ''}
                    >
                        고지서 출력
                    </Link>
                </li>
                <li>
                    <Link
                        to="/TotalNonPaymentHistory"
                        className={location.pathname === '/TotalNonPaymentHistory' ? 'active' : ''}
                    >
                        전체미납내역
                    </Link>
                </li>
                <li>
                    <Link
                        to="/CheckOut"
                        className={location.pathname === '/CheckOut' ? 'active' : ''}
                    >
                        퇴실관리
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default TopBar;
